import { createSelector } from 'reselect';
import { WebPushReducerState } from './types';

/**
 * webPushSelector
 * Selector for the webPush state.
 */
export const webPushSelector = (state: WebPushReducerState) =>
  state.integrations.webPushIntegrations;

/** Selects the web push integration that exists for the current project. Only 1 integration is allowed per project. */
export const selectWebPushIntegration = createSelector(
  [webPushSelector],
  ({ webPushIntegrations }) => (webPushIntegrations.length ? webPushIntegrations[0] : undefined),
);

/**
 * selectIsWebPushLoading
 * Selects the loading status for webPush data from state.
 */
export const selectIsWebPushLoading = createSelector(
  [webPushSelector],
  (webPush) => webPush.isLoading,
);
